"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ListStripePaymentMethodResponseSchema = exports.PayStripePrepayOrderSchema = exports.ListStripePaymentMethodQuerySchema = exports.DeleteStripePaymentMethodResponseSchema = exports.DeleteStripePaymentMethodBodySchema = exports.UpdateDefaultStripePaymentMethodResponseSchema = exports.UpdateDefaultStripePaymentMethodBodySchema = exports.StripePaymentMethodResponseSchema = exports.TeamOrderIdSchema = exports.CreateStripePaymentMethodResponseSchema = exports.CreateStripePaymentMethodBodySchema = exports.StripeRefSchema = void 0;
const typebox_1 = require("@sinclair/typebox");
const core_1 = require("../../../core");
exports.StripeRefSchema = typebox_1.Type.String();
const StripePaymentMethodBodySchema = (0, core_1.StrictObject)({
    paymentMethodRef: exports.StripeRefSchema,
});
exports.CreateStripePaymentMethodBodySchema = (0, core_1.StrictObject)({});
exports.CreateStripePaymentMethodResponseSchema = (0, core_1.StrictObject)({
    setupClientSecret: exports.StripeRefSchema,
});
exports.TeamOrderIdSchema = (0, core_1.StrictObject)({
    teamId: core_1.IdSchema,
    orderId: core_1.IdSchema,
});
exports.StripePaymentMethodResponseSchema = (0, core_1.StrictObject)({
    id: exports.StripeRefSchema,
    type: typebox_1.Type.String(),
    expiryMonth: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    expiryYear: typebox_1.Type.Optional(typebox_1.Type.Integer()),
    last4: typebox_1.Type.Optional(typebox_1.Type.String()),
    brand: typebox_1.Type.Optional(typebox_1.Type.String()),
    sortCode: typebox_1.Type.Optional(typebox_1.Type.String()),
    country: typebox_1.Type.Optional(typebox_1.Type.String()),
    defaultMethod: core_1.EnabledSchema,
});
exports.UpdateDefaultStripePaymentMethodBodySchema = StripePaymentMethodBodySchema;
exports.UpdateDefaultStripePaymentMethodResponseSchema = exports.StripePaymentMethodResponseSchema;
exports.DeleteStripePaymentMethodBodySchema = StripePaymentMethodBodySchema;
exports.DeleteStripePaymentMethodResponseSchema = exports.StripePaymentMethodResponseSchema;
exports.ListStripePaymentMethodQuerySchema = (0, core_1.createUnsortedPaginatedQuery)({});
exports.PayStripePrepayOrderSchema = (0, core_1.StrictObject)({});
exports.ListStripePaymentMethodResponseSchema = (0, core_1.createUnsortedListResponseSchema)(exports.StripePaymentMethodResponseSchema);
